<template lang="pug">
  .filter-box
    SmartForm(
      inline=true
      :formList="filterSlice"
      :columns="filterColumns"
      :values="filterValues"
      :buttonList="buttonList"
      @changeFormValue="changeFormValue")
    SeniorFilter(
      :dialogVisible="dialogVisible"
      :formList="filterList"
      :columns="filterColumns"
      @getFormValues="getSeniorFormValues"
      @dialogVisiStatus="setDialogVisible")
</template>
<script>
import SmartForm from '@/components/SmartForm'
import SeniorFilter from './SeniorFilter'

export default {
  name: 'FilterBox',
  components: {
    SmartForm,
    SeniorFilter
  },
  props: {
    columns: Object,
    columnHiddens: {
      type: Object,
      default: () => ({})
    },
    filterList: {
      type: Array,
      default: () => []
    },
    filterBy: {
      type: Array,
      default: () => []
    },
    values: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    filterSlice () {
      return this.filterList.length > 4 ? this.filterList.slice(0, 4) : this.filterList
    }
  },
  watch: {
    columnHiddens: {
      handler (newVal, oldVal) {
        Object.keys(newVal).map(key => {
          this.filterColumns[key].form.hidden = newVal[key]
        })
      },
      deep: true
    }
  },
  data () {
    let filterColumns = {}
    Object.keys(this.columns).map(key => {
      filterColumns[key] = {
        ...this.columns[key],
        form: {
          ...this.columns[key].filter,
          size: 'md'
        }
      }
    })
    let filterValues = {}
    this.filterBy.map(item => {
      filterValues[item.name] = item.value
    })
    Object.keys(this.values).map(key => {
      filterValues[key] = this.values[key]
    })
    return {
      dialogVisible: false,
      filterValues: filterValues,
      filterColumns: filterColumns,
      buttonList: [{
        name: 'search',
        label: '搜索',
        tooltip: true,
        icon: 'search',
        type: 'complete',
        validate: true,
        func: ({funcProps}) => {
          const { formValues } = funcProps.form
          const result = this.renderFilterBy(formValues)
          this.$emit('changeFilterBy', result)
        }
      }]
    }
  },
  methods: {
    getSeniorFormValues (value) {
      // console.info('seniorValue: ', value)
      const result = this.renderFilterBy(value)
      this.$emit('changeFilterBy', result)
    },
    changeFormValue (args) {
      this.$emit('changeFormValue', args)
    },
    setDialogVisible (status) {
      this.dialogVisible = status
    },
    renderFilterBy (formValues) {
      let filterBy = []
      const filterColumns = this.filterColumns
      Object.keys(formValues).map(key => {
        if (filterColumns[key]) {
          const columnFilter = filterColumns[key].filter
          if (columnFilter.type === 'daterange') {
            filterBy.push({
              name: key,
              type: 'ge',
              value: formValues[key].start || formValues[key][0]
            })
            filterBy.push({
              name: key,
              type: 'le',
              value: formValues[key].end || formValues[key][1]
            })
          } else {
            let type = 'eq'
            if (columnFilter.like) {
              type = 'like'
            }
            if (columnFilter.unequal) {
              type = 'ne'
            }
            filterBy.push({
              name: key,
              type: type,
              value: formValues[key]
            })
          }
        }
      })
      const result = filterBy.filter(item => {
        return item.value !== '' && item.value !== undefined && item.value !== null
      })
      return result
    }
  }
}
</script>

<style scoped lang="sass">
.filter-box
  /* width: 80% */
</style>



// WEBPACK FOOTER //
// index.vue?8d475ec8